import { render, staticRenderFns } from "./UIManager.vue?vue&type=template&id=41047c8d"
import script from "./UIManager.vue?vue&type=script&lang=js"
export * from "./UIManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports